// extracted by mini-css-extract-plugin
module.exports = {"component":"AspectRatio_component__CzOwR"};